export default __webpack_public_path__ + "static/media/logo.5b0cbcbf.svg";